import { jsx, jsxs } from "react/jsx-runtime";
import dedent from "dedent";
import { forwardRef } from "react";
import { useLinkComponent } from "../BraidProvider/BraidProvider.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { ButtonContainer, useButtonStyles, ButtonOverlays, ButtonText } from "../Button/Button.mjs";
import { Box } from "../Box/Box.mjs";
const ButtonLink = forwardRef(
  ({
    children,
    size,
    tone,
    variant,
    bleedY,
    bleed,
    icon,
    iconPosition,
    loading,
    data,
    ...restProps
  }, ref) => {
    const LinkComponent = useLinkComponent(ref);
    if (process.env.NODE_ENV !== "production") {
      if (typeof bleedY !== "undefined") {
        console.warn(
          dedent`
            The "bleedY" prop has been deprecated and will be removed in a future version. Use "bleed" instead.
               <Button
              %c-   bleedY
              %c+   bleed
               %c/>
          `,
          "color: red",
          "color: green",
          "color: inherit"
        );
      }
    }
    return /* @__PURE__ */ jsx(ButtonContainer, { bleed, variant, children: /* @__PURE__ */ jsxs(
      Box,
      {
        component: LinkComponent,
        ref,
        ...restProps,
        ...buildDataAttributes({ data, validateRestProps: false }),
        ...useButtonStyles({
          variant,
          tone,
          size,
          bleed: bleed || bleedY,
          loading
        }),
        children: [
          /* @__PURE__ */ jsx(ButtonOverlays, { variant, tone }),
          /* @__PURE__ */ jsx(
            ButtonText,
            {
              variant,
              tone,
              size,
              loading,
              icon,
              iconPosition,
              bleed,
              children
            }
          )
        ]
      }
    ) });
  }
);
ButtonLink.displayName = "ButtonLink";
export {
  ButtonLink
};
